module.exports = __webpack_public_path__ + "./img/logout.824a956584072f96abb88642b527594b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logout.png
// module id = ./assets/images/logout.png
// module chunks = 0